import { Redirect } from "react-router-dom";
import { compose, withHooks, withStores, withTranslation } from "enhancers";
import { Path, getTenantIdFromUrl } from "routes/paths";
import { useMemo } from "react";
import { MASTER_MENU, TENANTED_MENU } from "routes/menu";
import appStore from "stores/appStore";
import Modal from "./Modal";
import { gql } from "@apollo/client";
import { getTenantPath } from "utils/helper";

const GET_WORKSPACE = gql`
  query GET_WORKSPACE($id: String!) {
    workspace(id: $id) {
      id
      isMaster
    }
  }
`;

const enhancer = compose(
  withStores((stores: any) => ({
    currentUser: stores.appStore.currentUser,
  })),
  withTranslation({ prefix: "api" }),
  withHooks((props: any, hooks: any) => {
    const { currentUser, t } = props;
    const { useQuery } = hooks;

    const urlTenantId = getTenantIdFromUrl();
    const tenantId = urlTenantId || currentUser?.accessibleTenants?.[0];
    const { data: currentWorkspaceData, loading: workspaceLoading } = useQuery(
      GET_WORKSPACE,
      {
        variables: { id: tenantId },
        skip: !tenantId || !currentUser,
        fetchPolicy: "network-only",
      }
    );

    const to = useMemo(() => {
      let inputPath = props.to instanceof Path ? props.to.toString() : props.to;

      if (inputPath && typeof inputPath === "string" && tenantId) {
        inputPath = inputPath.replace(":tenantId", tenantId);
      }

      if (props.withPermissions) {
        const isMaster = currentWorkspaceData?.workspace?.isMaster || false;
        const menuToUse = isMaster ? MASTER_MENU : TENANTED_MENU;
        const userPermissions = currentUser?.role?.permissions || [];

        let goTo;
        for (const menu of menuToUse) {
          if (menu.children && menu.children.length > 0) {
            const permittedChild = menu.children.find((child: any) =>
              child.permissions?.every((perm: any) =>
                userPermissions.includes(perm)
              )
            );
            if (permittedChild) {
              goTo = permittedChild.path;
              break;
            }
          } else {
            const havePermission = menu.permissions?.every((perm: any) =>
              userPermissions.includes(perm)
            );
            if (havePermission) {
              goTo = menu.path;
              break;
            }
          }
        }
        if (goTo) {
          return getTenantPath(goTo, tenantId);
        } else if (!workspaceLoading) {
          Modal.alert({
            title: t(".modal403Title"),
            children: t(".modal403Children"),
            okButtonLabel: t(".modal403OkButtonLabel"),
            onOk: async ({ close }: any) => {
              appStore.logout();
              close();
            },
            disableBackdropClick: true,
          });
          return inputPath;
        } else {
          return inputPath;
        }
      } else {
        return inputPath;
      }
    }, [
      props.to,
      props.withPermissions,
      currentUser,
      t,
      currentWorkspaceData,
      workspaceLoading,
      tenantId,
    ]);

    return {
      ...props,
      to,
    };
  })
);

export default enhancer(Redirect);
